import {
    getCountryCallingCode,
    isValidPhoneNumber,
    parsePhoneNumber,
    parsePhoneNumberFromString,
} from 'libphonenumber-js/max';

import { countryCodeLookup } from './Address';

export const formatPhoneNumber = value => value.replace(/[^\d/+]/g, '');

export const validatePhone = (value, country = 'US') => {
    let phoneNumber = null;
    if (isValidPhoneNumber(value, country)) {
        // For international numbers starting with +, don't specify a country
        // Let libphonenumber-js determine the country from the number itself
        if (value.startsWith('+')) {
            phoneNumber = parsePhoneNumber(value);
        } else {
            const countryCode = countryCodeLookup(country);
            phoneNumber = parsePhoneNumberFromString(`${value}`, {
                defaultCountry: countryCode,
                defaultCallingCode: countryCode && getCountryCallingCode(countryCode),
            });
        }
        // Check that the phone number has a country (not an 800 number) and it's valid
        return phoneNumber?.country && phoneNumber.isValid();
    }

    return false;
};
